module.exports = "/images/default-avatar.png?522560c8ca5313e66b8c3c2616cc932c";